import useResizeObserver from '@react-hook/resize-observer';
import { useLayoutEffect, useState } from 'react';

function hasDomRectChanged(rect1: DOMRect | undefined, rect2: DOMRect | undefined): boolean {
  if (!rect1 || !rect2) {
    return rect1 !== rect2;
  }

  return (
    rect1.x !== rect2.x ||
    rect1.y !== rect2.y ||
    rect1.width !== rect2.width ||
    rect1.height !== rect2.height ||
    rect1.top !== rect2.top ||
    rect1.right !== rect2.right ||
    rect1.bottom !== rect2.bottom ||
    rect1.left !== rect2.left
  );
}

export const useMeasureNew = (target: HTMLDivElement | HTMLElement | null): DOMRect | undefined => {
  const [size, setSize] = useState<DOMRectReadOnly>();

  useLayoutEffect(() => {
    const boundingTarget = target?.getBoundingClientRect();
    if (hasDomRectChanged(size, boundingTarget)) {
      setSize(boundingTarget);
    }
  }, [target, size]);

  // Does not include margins, padding
  // https://github.com/microsoft/TypeScript/issues/49271
  // https://github.com/JacobLey/jacobley/blob/main/tools/default-import/src/default-import.ts
  useResizeObserver(target, (entry: ResizeObserverEntry) => {
    setSize(entry.contentRect);
  });

  return size;
};
